export const permissionsForComponents = [
  /**  system permissions **/

  // dashboard
  { role: "viewDashboard", component: "Dashboard" },

  // permissions
  { role: "viewRole", component: "Permissions" },

  // staff's records
  { role: "viewStaff", component: "User Managment" },

  // content
  { role: "viewContent", component: "Content" },
  { role: "viewContent", component: "cms" },
  { role: "deleteContent", component: "Delete Content" },
  { role: "addContent", component: "Add Content" },
  { role: "editContent", component: "Edit Content" },
  // CMS

  // category
  { role: "viewCategory", component: "Categories" },

  { role: "viewSlider", component: "Slider" },

  // settings
  { role: "viewSetting", component: "Settings" },

  // about
  { role: "viewAbout", component: "About" },

  // team members
  { role: "viewTeamMember", component: "Team Members" },

  // DOCUMENTS
  { role: "viewDocument", component: "Documents" },

  // GALLERY
  { role: "viewGallery", component: "Gallery" },

  { role: "viewEvent", component: "Events" },
  { role: "viewEvent", component: "View Event" },
  { role: "addEvent", component: "Add Event" },
  { role: "editEvent", component: "Edit Event" },
];
